/**
 * `wpp::navigation`
 *
 * Whether the sidebar is showing labels or only icons. Remembered, because it is
 * a standing preference about how somebody wants to work rather than a decision
 * about the page they are on.
 *
 * @param {{ collapsed?: boolean, persistAs?: string }} options
 */
export default function collapsibleNav(options = {}) {
    return {
        collapsed: this.$persist(options.collapsed ?? false).as(options.persistAs ?? 'app.menu.collapsed'),

        toggle() {
            this.collapsed = ! this.collapsed;
        },
    };
}
